import _Reflect$construct from '@babel/runtime-corejs3/core-js/reflect/construct';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _assertThisInitialized from '@babel/runtime-corejs3/helpers/assertThisInitialized';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _Set from '@babel/runtime-corejs3/core-js/set';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js/instance/index-of';
import _spliceInstanceProperty from '@babel/runtime-corejs3/core-js/instance/splice';
import * as React from 'react';
import classNames from 'classnames';
import { api } from '@bilibili-maoer/web-utils';
import { throttle } from 'lodash-es';
import { prependPrefix } from '../../utils/style.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DEFAULT_IMAGE = "".concat(api.MISSEVAN_CDN_PREFIX_URL, "/assets/images/index/lazy_load.png");
var IMAGE_LOAD_OFFSET = 200;
var IMAGE_LOAD_DURATION = 300;
var MAX_LOADED_IMAGE = 2000;
var lazyImages = [];
var loadedImages = new _Set();
var listenerAddedNodes = new _Set();

var findScrollableParent = function findScrollableParent(node) {
  if (!(node instanceof HTMLElement)) {
    return window;
  }

  var current = node;
  var parent = current.parentNode;

  while (parent) {
    var nodeClassName = parent.className; // 寻找是否存在是 Scrollable 组件的父元素

    if (/scrollable/.test(nodeClassName)) {
      if (/css-scrollbar/.test(nodeClassName)) {
        return parent;
      }

      return current;
    }

    if (!parent.parentNode) {
      return window;
    }

    current = parent;
    parent = parent.parentNode;
  }

  return window;
};

var LegacyLazyImage = /*#__PURE__*/function (_React$Component) {
  _inherits(LegacyLazyImage, _React$Component);

  var _super = _createSuper(LegacyLazyImage);

  function LegacyLazyImage(props) {
    var _this;

    _classCallCheck(this, LegacyLazyImage);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "lazyImageRef", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "lazyImageDivRef", /*#__PURE__*/React.createRef());

    var isLoadedImage = !props.src || loadedImages.has(props.src);
    _this.state = {
      status: isLoadedImage ? 'loaded' : 'prepared',
      src: isLoadedImage ? props.src || DEFAULT_IMAGE : DEFAULT_IMAGE
    };
    return _this;
  }

  _createClass(LegacyLazyImage, [{
    key: "position",
    get: function get() {
      var lazyImage = this.lazyImageRef.current || this.lazyImageDivRef.current;
      return lazyImage === null || lazyImage === void 0 ? void 0 : lazyImage.getBoundingClientRect();
    }
  }, {
    key: "status",
    get: function get() {
      return this.state.status;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var hasScrollableParent = this.props.hasScrollableParent;
      var status = this.state.status;

      if (status !== 'prepared') {
        return;
      }

      if (!hasScrollableParent) {
        if (!listenerAddedNodes.has(window)) {
          LegacyLazyImage.addNodeListener(window);
        }
      } else {
        var lazyImage = this.lazyImageRef.current || this.lazyImageDivRef.current;
        var node = findScrollableParent(lazyImage);

        if (node && !listenerAddedNodes.has(node)) {
          // TODO: 在图片全部加载完成或者全部被移除后，需要移除滚动监听
          LegacyLazyImage.addNodeListener(node);
        }
      }

      LegacyLazyImage.updateLazyImage(this);
    } // eslint-disable-next-line @typescript-eslint/naming-convention

  }, {
    key: "UNSAFE_componentWillReceiveProp",
    value: function UNSAFE_componentWillReceiveProp(nextProps) {
      var _nextProps$src = nextProps.src,
          src = _nextProps$src === void 0 ? DEFAULT_IMAGE : _nextProps$src;

      if (src !== this.props.src) {
        this.setState({
          src: src
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      LegacyLazyImage.removeLazyImage(this);
    }
  }, {
    key: "load",
    value: function load() {
      var _this2 = this;

      var src = this.props.src;
      var image = new Image();

      image.onload = function () {
        _this2.setState({
          status: 'loaded',
          src: src
        });

        LegacyLazyImage.removeLazyImage(_this2);

        if (loadedImages.size > MAX_LOADED_IMAGE - 1) {
          // TODO: 缓存的图片超过 2000 之后，清空 loadedImages，如果效果不好可以替换为数组清空前 100 条记录
          loadedImages.clear();
        }

        loadedImages.add(src);
      };

      image.src = src;
      this.setState({
        status: 'loading'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          src = _this$state.src,
          status = _this$state.status;
      var _this$props = this.props,
          className = _this$props.className,
          alt = _this$props.alt,
          children = _this$props.children,
          divComponent = _this$props.divComponent;
      var realClassName = classNames(prependPrefix('lazy-image'), "lazy-".concat(status), className);
      return children || divComponent ? /*#__PURE__*/React.createElement("div", {
        title: alt,
        style: {
          backgroundImage: "url(".concat(src, ")")
        },
        className: realClassName,
        ref: this.lazyImageDivRef
      }, children) : /*#__PURE__*/React.createElement("img", {
        alt: alt,
        src: src,
        title: alt,
        className: realClassName,
        ref: this.lazyImageRef
      });
    }
  }], [{
    key: "loadImage",
    value: function loadImage(ref) {
      var seeHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      var pos = ref.position;

      if (!pos) {
        return;
      }

      var top = pos.top,
          bottom = pos.bottom;

      if (ref.status === 'prepared' && bottom > -IMAGE_LOAD_OFFSET && top < seeHeight + IMAGE_LOAD_OFFSET) {
        ref.load();
      }
    }
  }, {
    key: "lazyLoadObserver",
    value: function lazyLoadObserver() {
      lazyImages.forEach(LegacyLazyImage.loadImage);
    }
  }, {
    key: "updateLazyImage",
    value: function updateLazyImage(ref) {
      if (ref.status === 'prepared') {
        lazyImages.push(ref);
        LegacyLazyImage.loadImage(ref);
      }
    }
  }, {
    key: "removeLazyImage",
    value: function removeLazyImage(ref) {
      var idx = _indexOfInstanceProperty(lazyImages).call(lazyImages, ref);

      if (idx !== -1) {
        _spliceInstanceProperty(lazyImages).call(lazyImages, idx, 1);
      }
    }
  }, {
    key: "addNodeListener",
    value: function addNodeListener(node) {
      listenerAddedNodes.add(node);
      node.addEventListener('scroll', throttle(LegacyLazyImage.lazyLoadObserver, IMAGE_LOAD_DURATION), false);
      node.addEventListener('resize', throttle(LegacyLazyImage.lazyLoadObserver, IMAGE_LOAD_DURATION), false);
    }
  }]);

  return LegacyLazyImage;
}(React.Component);

export { LegacyLazyImage };
